// extracted by mini-css-extract-plugin
module.exports = {"social":"Social_social__AOBAb","iconWrapper":"Social_iconWrapper__LCx9a","socialLink":"Social_socialLink__dBaKx"};